import React, { useState, useEffect } from "react";
import styled from "styled-components";
// import Calendar from "../../Components/Calendar/Calendar";
import Modal from "../../Components/Kanban/Modal/Modal";
import { useSession } from "../../authentications/SessionContext";
// import kanbanGrey from "../../Images/kanbanGrey.svg";
// import kanban from "../../Images/kanban.svg";
// import Orangetasklist from "../../Images/Orangetasklist.svg";
// import OrangeGrey from "../../Images/OrangeGrey.svg";
import { useDispatch } from "react-redux";
import { contactsAction } from "../../Redux/Reducers/ContactsSlice";
import { PAGINATION_DEFAULT_LIMIT } from "../../utilities/constants";
import filterSign from "../../Images/filterSign.svg";
import ReactSelect from "react-select";
import Contactskanban from "../../Components/ContactsComponents/Contactskanban/Contactskanban";
// import ContactsTaskList from "../../Components/ContactsComponents/ContactsTasklist";
import AddNewContact from "../../Components/ContactsComponents/AddNewContact";
import { useLanguage } from "../../Components/LangTranslation/LanguageContext";
import useConfirmationModal from "../../Components/ConfirmationModal/useConfirmationModal";
import { unLink } from "../../DataApi/unlink";
import { handleResponse } from "../../utilities/handleResponse";

const ContactsFilterList = [
  {
    label: "Individuals",
    value: JSON.stringify([["is_company", "=", false]]),
  },
  {
    label: "Companies",
    value: JSON.stringify([["is_company", "=", true]]),
  },
  { label: "All", value: "" },
];

const WarehouseTasklistSortList = [
  { label: "Default", value: "create_date" },
  { label: "Name", value: "display_name" },
  { label: "Phone", value: "phone" },
  { label: "Email", value: "email" },
  { label: "City", value: "city" },
  { label: "Country", value: "country_id" },
  { label: "Company", value: "is_company" },
];

// const ButtonContainer = styled.div`
//   display: flex;
//   margin-right: 9px;
//   .btn-group {
//     width: 210px;
//     background-color: #f8f9fa !important;
//   }
// `;
// const CustomButton = styled.button`
//   &&&.custom-button {
//     background-color: ${(props) => (props.active ? "#fff" : "#fff")};
//     border: none;
//     border-radius: 32%;
//     height: 38px;
//     width: 16px;
//     display: flex;
//     margin: 10px;
//     justify-content: center;
//     padding: 5px;
//     cursor: pointer;

//     &:hover {
//       background-color: #fff;
//     }
//   }
// `;
const ContactsFirstSec = styled.div`
  display: flex;
  gap: 30px;
  margin-left: 12px;

  .Filter_icon_div {
    width: 50px;
    height: 47px !important;
    border-radius: 30% !important;
    background-color: #f8f9fa !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    margin-left: 10px;
  }
  .dropdown_list_div {
    background-color: #f8f9fa;
    height: 45px;
    color: #b0b7c3;
    font-size: 14px;
    font-family: "Inter";
    border-radius: 14px;
    border: none;
    background-color: #f8f9fa;
    padding: 6px;
    border: none;
    margin-left: 10px;
  }
  .dropdown_list_div select {
    padding: 4px 14px;
    background-color: transparent;
    border: 0;
    color: #000000;
    font-size: 16px;
    width: auto;
    font-family: "Inter";
    &:focus {
      border: none;
      outline: none;
    }
  }

  option {
    font-size: 16px;
    line-height: 6;
    padding: 12px !important;
    font-family: "Inter";
    margin: 10px !important;
  }
  .sort_by {
    margin-top: 6px;
    margin-right: 10px;
    font-size: 16px;
  }
  .reactSelect {
    margin-right: 10px;
  }
  .Filter_icon_div img {
    transition: transform 0.3s ease;
  }
`;
const LeftDiv = styled.div`
  margin-top: 10px;
  margin-left: 8px;
`;

const NewButton = styled.button`
  border-radius: 15px;
  background-color: #ff5837;
  color: #ffffff;
  border: none;
  width: 130px;
  min-width: 125px;
  height: 40px;
  margin-right: 20px;
`;

const Contacts = () => {
  const dispatch = useDispatch();

  const { language, translations } = useLanguage();
  const t = translations[language];
  const { changeview, selectedView, sessionInfo } = useSession();
  const [searchQuery, setSearchQuery] = useState("");

  const { company_id, context, company_partner_id } = sessionInfo;
  const [searchType, setSearchType] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);

  const [selectedRecord, setSelectedRecord] = useState(null);
  const [searchWithType, setSearchWithType] = useState("");

  const {
    setIsDisabled: setDisableModalButton,
    ConfirmationModal,
    setTitle,
    setMetaData,
    toggleModal,
    setOpenModal: setOpenConfirmationModal,
  } = useConfirmationModal();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [ContactsTypeFilter, setContactsTypeFilter] = useState(
    ContactsFilterList[0]
  );
  const [filterDirection, setFilterDirection] = useState("desc");

  const [TasklistSorting, setTasklistSorting] = useState(
    WarehouseTasklistSortList[0].value
  );
  const handleChangeContactsTypeFilter = (value, e) => {
    setContactsTypeFilter(value);
  };

  const handleChangeTasklistSortingType = (e) => {
    setTasklistSorting(e.target.value);
  };
  const handleCreateClick = () => {
    setIsModalOpen(true);
  };
  const handleChangeSearch = (e) => {
    setSearchWithType(e.target.value);
    if (e.target.value === "") {
      setSearchQuery("");
    }
  };
  const handleSubmitSearch = (e) => {
    e.preventDefault();
    setSearchQuery(searchWithType);
  };

  const handleChangeTasklistSorting = () => {
    setFilterDirection(filterDirection === "asc" ? "desc" : "asc");
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
    refetchData();
    setSelectedRecord(null);
  };

  const refetchData = ({ offset = 0 } = {}) => {
    dispatch(
      contactsAction.fetchContactsData({
        selectedView,
        company_id,
        context,
        company_partner_id,
        pagination: {
          limit: PAGINATION_DEFAULT_LIMIT,
          offset,
        },
        search: {
          query: searchType ? searchWithType : searchQuery,
          type: ContactsTypeFilter?.value || "",
        },
        sort: {
          type: TasklistSorting || "",
          dir: filterDirection,
        },
      })
    );
  };
  useEffect(() => {
    refetchData({});
  }, [
    selectedView,
    searchQuery,
    searchType,
    TasklistSorting,
    filterDirection,
    ContactsTypeFilter,
  ]);

  return (
    <div>
      {/* <ConfirmationModal
        handleYes={handleDeleteSelection}
        handleNo={() => setOpenConfirmationModal(false)}
      /> */}
      {/* {isModalOpen && ( */}
      <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
        <AddNewContact
          selectedRecord={selectedRecord}
          handleCloseModal={() => {
            setSelectedRows([]);
            handleCloseModal();
            refetchData();
          }}
        />
      </Modal>
      {/* )} */}

      <div className="d-flex justify-content-between">
        <LeftDiv className="">
          <ContactsFirstSec>
            <div className=" d-none d-md-flex reactSelect">
              <ReactSelect
                value={ContactsTypeFilter}
                options={ContactsFilterList}
                name="type"
                onChange={handleChangeContactsTypeFilter}
              />
            </div>

            <div className="Filter_icon_div">
              <img
                src={filterSign}
                alt="filter"
                style={{
                  transform: `rotate(${
                    filterDirection === "asc" ? "180" : "0"
                  }deg)`,
                }}
                onClick={handleChangeTasklistSorting}
              />
            </div>
            <div className=" d-none d-md-flex dropdown_list_div d-flex">
              <div className="sort_by">Sort by:</div>

              <select
                className="custom-select"
                onChange={handleChangeTasklistSortingType}
                value={TasklistSorting}
                name="type"
              >
                {WarehouseTasklistSortList.map((option, index) => (
                  <option
                    key={index}
                    value={option.value}
                    style={{ padding: "15px 0" }}
                  >
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          </ContactsFirstSec>
        </LeftDiv>

        <div>
          <NewButton onClick={handleCreateClick}>+ {t["Add new"]}</NewButton>
        </div>
        {/* 
        <ButtonContainer>
          <div className="btn-group" role="group" aria-label="Basic example">
            <CustomButton
              type="button"
              className={`btn btn-custom custom-button ${
                selectedView === "kanbanView" ? "active" : ""
              }`}
              active={selectedView === "kanbanView" ? "true" : "false"} // Pass as string
              onClick={() => changeview("kanbanView")}
            >
              <div>
                <Image
                  className="custom-image"
                  src={selectedView === "kanbanView" ? kanban : kanbanGrey}
                  alt="Profile Image"
                />
              </div>
            </CustomButton>
            <CustomButton
              type="button"
              className={`btn btn-custom custom-button ${
                selectedView === "taskList" ? "active" : ""
              }`}
              active={selectedView === "taskList" ? "true" : "false"}
              onClick={() => changeview("taskList")}
            >
              <div>
                <Image
                  className="custom-image"
                  src={
                    selectedView === "taskList" ? Orangetasklist : OrangeGrey
                  }
                />
              </div>
            </CustomButton>
            <CustomButton
              type="button"
              className={`btn btn-custom custom-button ${
                selectedView === "timeoff" ? "active" : ""
              }`}
              active={selectedView === "timeoff" ? "true" : "false"}
              onClick={() => changeview("timeoff")}
            >
              <div>
                <Image
                  className="custom-image"
                  src={
                    selectedView === "timeoff"
                      ? require("../../Images/Calender.png")
                      : require("../../Images/CalendarG.png")
                  }
                  alt="Profile Image"
                />
              </div>
            </CustomButton>
          </div>
        </ButtonContainer>*/}
      </div>

      {/* {selectedView === "kanbanView" ? ( */}
      <Contactskanban
        handleChangeSearch={handleChangeSearch}
        handleSubmitSearch={handleSubmitSearch}
        searchWithType={searchWithType}
        selectedRecord={selectedRecord}
        setSelectedRecord={setSelectedRecord}
        refetchData={refetchData}
        handleCreateClick={handleCreateClick}
      />
      {/* ) : selectedView === "timeoff" ? (
        <Calendar />
      ) : (
        <ContactsTaskList refetchData={refetchData} />
      )} */}
    </div>
  );
};

export default Contacts;
